import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Form, Button, Container } from "react-bootstrap";
import DriverSelector from "../../components/driverSelector";
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

const getWeekRange = (weekNumber) => {
    const year = new Date().getFullYear();
    const firstMonday = new Date(year, 0, 1);

    // Знаходимо перший понеділок року
    while (firstMonday.getDay() !== 1) {
        firstMonday.setDate(firstMonday.getDate() + 1);
    }

    const weekStart = new Date(firstMonday);
    weekStart.setDate(firstMonday.getDate() + (weekNumber - 1) * 7);

    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);

    const formatDate = (date) =>
        date.toLocaleDateString(
            i18n.language === "pl"
                ? "pl-PL"
                : i18n.language === "en"
                    ? "en-GB"
                    : "uk-UA", // default
            {
                day: "2-digit",
                month: "2-digit",
            }
        );

    return `${formatDate(weekStart)} – ${formatDate(weekEnd)}`;
};

const getAlternatingMonthColor = (weekNumber) => {
    const year = new Date().getFullYear();
    const firstMonday = new Date(year, 0, 1);
    while (firstMonday.getDay() !== 1) {
        firstMonday.setDate(firstMonday.getDate() + 1);
    }

    const weekStart = new Date(firstMonday);
    weekStart.setDate(firstMonday.getDate() + (weekNumber - 1) * 7);
    const month = weekStart.getMonth(); // 0 = січень

    // Темніший сірий: #e9ecef (Bootstrap light gray)
    return month % 2 === 0 ? "#e9ecef" : "#ffffff";
};




const IncomeData = () => {
    const { t } = useTranslation();
    const [isInitialized, setIsInitialized] = useState(false);

    const [selectedWeeks, setSelectedWeeks] = useState([]);
    const [incomeData, setIncomeData] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [selectedFirstName, setSelectedFirstName] = useState("");
    const [selectedLastName, setSelectedLastName] = useState("");
    const weeks = Array.from({ length: 52 }, (_, i) => i + 1);
    const [payoutData, setPayoutData] = useState([]);

    useEffect(() => {
        console.log("🔍 Виконується запит на отримання користувачів...");
        fetch("/api/users")
            .then(response => response.json())
            .then(data => {
                console.log("📋 Отримані користувачі:", data);
                setUsers(data);
            })
            .catch(error => console.error("❌ Помилка завантаження користувачів:", error));
    }, []);

    useEffect(() => {
        const stored = localStorage.getItem("selectedWeeks");
        if (stored) {
            const parsed = JSON.parse(stored);
            const now = new Date().getTime();
            const oneDay = 24 * 60 * 60 * 1000;

            if (now - parsed.timestamp < oneDay) {
                setSelectedWeeks(parsed.weeks);
            } else {
                localStorage.removeItem("selectedWeeks");
            }
        }
        setIsInitialized(true); // ✅ Встановлюємо прапорець
    }, []);


    useEffect(() => {
        if (!isInitialized) return; // ❗ Не зберігати, поки не завантажено
        const now = new Date().getTime();
        localStorage.setItem("selectedWeeks", JSON.stringify({
            weeks: selectedWeeks,
            timestamp: now
        }));
    }, [selectedWeeks, isInitialized]);





    const handleCheckboxChange = (week) => {
        setSelectedWeeks((prevSelected) =>
            prevSelected.includes(week)
                ? prevSelected.filter((w) => w !== week)
                : [...prevSelected, week]
        );
    };

    const handleUserChange = (e) => {
        const userId = Number(e.target.value);
        const selected = users.find(user => user.id === userId);

        if (selected) {
            setSelectedUser(userId);
            setSelectedFirstName(selected.firstName);
            setSelectedLastName(selected.lastName);
            console.log("✅ Вибрано користувача:", selected.firstName, selected.lastName);
        } else {
            setSelectedUser("");
            setSelectedFirstName("");
            setSelectedLastName("");
            console.log("⚠️ Користувач не знайдений");
        }
    };

    const fetchIncomeData = () => {
        const [selectedFirstName, selectedLastName] = selectedUser.label.split(" ");
        const token = localStorage.getItem("token"); // якщо токен потрібен

        if (selectedWeeks.length === 0 || !selectedFirstName || !selectedLastName) {
            console.error("❌ Відсутні необхідні дані!", { selectedWeeks, selectedFirstName, selectedLastName });
            return;
        }

        // Конвертуємо номери тижнів у формат 202531
        const currentYear = new Date().getFullYear();
        const formattedWeeks = selectedWeeks.map(week => `${currentYear}${String(week).padStart(2, '0')}`);

        console.log("📤 Відправляємо дані:", { weeks: formattedWeeks, first_name: selectedFirstName, last_name: selectedLastName, driver_id: selectedUser.value });

        axios.post("/api/cash-data", {
            weeks: formattedWeeks,
            first_name: selectedFirstName,
            last_name: selectedLastName,
            driver_id: selectedUser.value
        }, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })
            .then((response) => {
                const formattedData = response.data.map(row => ({
                    ...row,
                    income: row.source === 'Uber' ? Math.abs(parseFloat(row.income)) || 0 : parseFloat(row.income) || 0
                }));
                setIncomeData(formattedData);
            })
            .catch((error) => {
                console.error("❌ Помилка отримання даних:", error);
                console.error("❌ Деталі помилки:", error.response?.data);
            });

        axios.post("/api/payouts-by-weeks", {
            driver_id: selectedUser.value,
            weeks: formattedWeeks
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })
            .then((response) => {
                console.log("📦 Отримані payout:", response.data);
                // Виправляємо payout дані, якщо вони прийшли як 0 через помилку парсингу
                const correctedPayoutData = response.data.map(p => {
                    if (p.payout === 0) {
                        // Якщо payout = 0, але є дані в БД, спробуємо отримати правильні дані
                        console.log(`⚠️ Payout для тижня ${p.week_number} = 0, можлива помилка парсингу`);
                    }
                    return p;
                });
                setPayoutData(correctedPayoutData);
            })
            .catch((error) => {
                console.error("❌ Помилка отримання payout:", error);
            });

    };

    const calculateTotals = () => {
        const totals = {};
        incomeData.forEach(({ source, income }) => {
            if (!totals[source]) {
                totals[source] = 0;
            }
            totals[source] += income;
        });
        return totals;
    };

    const totals = calculateTotals();
    const getWeekRowClass = (weekNumber) => {
        return weekNumber % 2 === 0 ? "table-white" : "table-secondary";
    };
    return (
        <Container>
            <h2 className="mt-4">{t("cashStatsTitle")}</h2>
            <Form.Group className="mb-3">
                <Form.Label>{t("chooseDriver")}</Form.Label>
                <DriverSelector selectedDriver={selectedUser} setSelectedDriver={setSelectedUser} />

            </Form.Group>
            <div className="row row-cols-2 row-cols-sm-4 row-cols-md-6 row-cols-lg-8 g-2 mb-4">
                {weeks.map((week) => (
                    <div className="col" key={week}>
                        <div
                            className={`border rounded px-2 py-1 text-center ${selectedWeeks.includes(week) ? 'text-white' : ''}`}
                            style={{
                                backgroundColor: selectedWeeks.includes(week)
                                    ? "#0d6efd"
                                    : getAlternatingMonthColor(week),
                                fontSize: "0.82rem",
                                lineHeight: "1.2",
                                cursor: "pointer",
                                userSelect: "none"
                            }}
                            onClick={() => handleCheckboxChange(week)}
                        >
                            <Form.Check
                                type="checkbox"
                                id={`week-${week}`}
                                checked={selectedWeeks.includes(week)}
                                onChange={() => handleCheckboxChange(week)}
                                className="d-inline-block me-2"
                            />
                            <label htmlFor={`week-${week}`} className="form-check-label">
                                <strong>{week}</strong><br />
                                <span style={{ fontSize: "0.72rem" }}>{getWeekRange(week)}</span>
                            </label>
                        </div>
                    </div>
                ))}
            </div>




            <Button
                onClick={fetchIncomeData}
                variant="primary"
                disabled={!selectedUser || selectedWeeks.length === 0}
            >
                {t("getData")}
            </Button>
            <h5 className="mt-4">{t("cash")}</h5>
            <Table bordered hover style={{ tableLayout: "fixed" }}>
                <thead>
                    <tr>
                        <th style={{ width: "33%" }}>{t("week")}</th>
                        <th style={{ width: "33%" }}>{t("service")}</th>
                        <th style={{ width: "34%" }}>{t("cash")}</th>
                    </tr>
                </thead>
                <tbody>
                    {incomeData.map((row, index) => (
                        <tr key={index} className={getWeekRowClass(parseInt(row.week_number.toString().slice(-2)))}>
                            <td>{row.week_number.toString().slice(-2)}</td>
                            <td>{row.source}</td>
                            <td>{row.income}</td>
                        </tr>
                    ))}
                    {Object.entries(totals).map(([source, total], index) => (
                        <tr key={`total-${index}`} className="table-success fw-bold">
                            <td colSpan={2}>{t("total")} ({source})</td>
                            <td>{total.toFixed(2)}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <h5 className="mt-4">{t("cash")} + {t("payout")}</h5>
            <Table bordered hover style={{ tableLayout: "fixed" }}>
                <thead>
                    <tr>
                        <th style={{ width: "33%" }}>{t("week")}</th>
                        <th style={{ width: "33%" }}>{t("payout")}</th>
                        <th style={{ width: "34%" }}>{t("payout").toLocaleLowerCase()} + {t("cash").toLocaleLowerCase()}</th>
                    </tr>
                </thead>
                <tbody>
                    {payoutData.map((p, index) => {
                        const incomesThisWeek = incomeData
                            .filter(row => row.week_number === p.week_number)
                            .reduce((sum, row) => sum + (row.income || 0), 0);
                        const total = p.payout + incomesThisWeek;

                        return (
                            <tr key={index} className={getWeekRowClass(parseInt(p.week_number.toString().slice(-2)))}>
                                <td>{p.week_number.toString().slice(-2)}</td>
                                <td>{p.payout.toFixed(2)}</td>
                                <td>{total.toFixed(2)}</td>
                            </tr>
                        );
                    })}

                </tbody>
                <tfoot>
                    <tr className="table-success fw-bold">
                        <td>{t("total")}</td>
                        <td>
                            {payoutData.reduce((sum, p) => sum + p.payout, 0).toFixed(2)}
                        </td>
                        <td>
                            {payoutData.reduce((sum, p) => {
                                const income = incomeData
                                    .filter(row => row.week_number === p.week_number)
                                    .reduce((sub, r) => sub + (r.income || 0), 0);
                                return sum + p.payout + income;
                            }, 0).toFixed(2)}
                        </td>
                    </tr>
                </tfoot>
            </Table>



        </Container>
    );
};

export default IncomeData;
